<script lang="ts">
  import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
  import emblaCarouselSvelte, {
    type EmblaCarouselSvelteType,
  } from "embla-carousel-svelte";

  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import { isBackgroundPlayerPaused } from "../../../stores/playerStore.ts";
  import ButtonBlock from "@components/blocks/Buttons/ButtonBlock.svelte";
  import type { SlideFieldset } from "../../../types/fieldsets";
  import type { TextField } from "../../../types/statamicFields";
  import Autoplay from "embla-carousel-autoplay";
  import LayeredSection from "@components/layout/LayeredSection.svelte";

  /**
   * Props
   */
  export let slides: SlideFieldset[] = [];
  export let title: TextField = "";
  export let delay: number = 4000;

  /**
   * Embla Carousel Options
   */
  const options = { loop: true, delay };
  let plugins = [Autoplay(), WheelGesturesPlugin()];
  let embla: any;
  let videos = slides.map((slide) => null as HTMLVideoElement | null);

  /**
   * Local State
   */
  let activeSlideIndex = 0;
  let previousSlideIndex = 0;

  /**
   * Lifecycle
   */
  function onInit(event: CustomEvent<EmblaCarouselSvelteType>) {
    embla = event.detail;
    videos[0]?.play();
    embla.on("select", () => {
      previousSlideIndex = activeSlideIndex;
      activeSlideIndex = embla.selectedScrollSnap();
      !$isBackgroundPlayerPaused && videos[activeSlideIndex]?.play();
      $isBackgroundPlayerPaused || videos[previousSlideIndex]?.pause();
    });
  }
</script>

<header
  class="container flex justify-center bg-cover bg-center pt-32 md:pt-48 pb-4 text-white"
>
  <h1 class="wah-h1 text-white normal-case">{title}</h1>
</header>
<div
  class="embla"
  use:emblaCarouselSvelte={{ options, plugins }}
  on:emblaInit={onInit}
>
  <div class="embla__container">
    {#each slides as slide, index}
      <div class="embla__slide">
        <a href={slide?.button?.href}>
          <LayeredSection
            bind:video={videos[index]}
            addClasses="rounded-xl md:rounded-3xl aspect-video md:aspect-[2 / 1] overflow-hidden box-border flex  h-full items-start
            justify-start items-end overflow-hidden bg-cover bg-center "
            layers={[
              {
                backgroundVideo: {
                  videoUrl: slide.background_video_url || "",
                  imageUrl:
                    convertStatamicAssetToCDN(slide.background_image?.id) || "",
                },
              },
            ]}
          >
            <div class="z-10 p-4 md:p-8">
              {#if slide.leader}
                <p class="wah-h5 text-p100">{slide.leader}</p>
              {/if}
              {#if slide.title}
                <h2 class="wah-h2 text-white">{slide.title}</h2>
              {/if}
              {#if slide.description}
                <p
                  class="hidden md:block text-body-large font-light text-white"
                >
                  {slide.description}
                </p>
              {/if}
              {#if slide.button}
                <ButtonBlock
                  class="hidden md:inline-flex"
                  {...{ ...slide.button, color: "white" }}
                  type="button"
                />
              {/if}
            </div>
          </LayeredSection>
        </a>
      </div>
    {/each}
  </div>
</div>

<style>
  .embla {
    overflow: hidden;
  }
  .embla__container {
    display: flex;
  }
  .embla__slide {
    flex: 0 0 80%;
    margin-right: 10px;
    margin-left: 10px;
    max-width: 1285px;
  }
</style>
